export default "__VITE_ASSET__79976c42__"